import React, {useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import AddressModal from "../../AddressModal/AddressModal";
import InfoModal from "../../InfoModal/InfoModal";
import bakBudget from '../../../pdf/bakBudget.pdf';
import bakPay from '../../../pdf/bakPay.pdf';
import personalData from '../../../pdf/personalData.pdf';
import agreedVo from '../../../pdf/agreedVo.pdf';

const App2 = () => {
    const [showAddressModal, setShowAddressModal] = useState(false);
    const modalRef = useRef(null);
    const handleShowAddressModal = () => setShowAddressModal(true);
    const handleCloseAddressModal = () => setShowAddressModal(false);
    const addressForSendingDocumentsTitle = "Адрес для отправки документов";
    const addressForSendingDocuments = (
        <>
            <p>
                Вы можете направить документы по следующему адресу Приемной комиссии:
                140155, Московская обл., Раменский муниципальный округ, пос. Электроизолятор, д. 67.
            </p>
            <p>
                Отправлять документы нужно заказным письмом или бандеролью с описью вложения
                и уведомлением. Заказному отправлению присваивается уникальный трек-номер.
                Он позволяет отследить на сайте{" "}
                <a
                    href="https://www.pochta.ru"
                    target="_blank" rel="noopener noreferrer">
                    Почты России
                </a>{" "}
                или в мобильном приложении Почты России.
                Весь путь письма и проконтролировать его доставку получателю. Опись вложения является
                гарантией того, что вы предоставили в вуз все необходимые документы.
                Сохраняйте квитанцию, которую вам выдадут в почтовом отделении. Именно на ней указан
                трек-номер. Он понадобится для отслеживания, а также, если возникнут вопросы по доставке отправления.
            </p>
        </>
    );

    return (
      <div className="DocumentLinksPage__content-container">
        <h2>Информация и документы, необходимые для поступления</h2>
        <h6>Документы, представляемые при подаче заявления для граждан РФ:</h6>
        <ul>
          <li>Документ, удостоверяющий личность, гражданство</li>
          <li>Документ об образовании</li>
          <li>4 фото (цветные) размером 3х4</li>
          <li>Страховой номер индивидуального лицевого счета (СНИЛС)</li>
          {/* <li>Медицинская справка 086У</li> */}
          <li>
            Паспорт или иной документ, удостоверяющий личность, законного
            представителя (для несовершеннолетних абитуриентов)
          </li>
          <li>Документы воинского учета (при наличии)</li>
        </ul>
        <p
          style={{
            padding: "10px",
            color: "white",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "#eb3434",
          }}
        >
          Начало приема документов с 20 июня {new Date().getFullYear()} года.
          Подавать документы можно не дожидаясь результатов ЕГЭ!
        </p>
        <p>
          <Link
            to={bakBudget}
            target="_blank"
          >
            Заявления на поступление (Бюджет)
          </Link>{" "}
          <br />
          <Link
            to={bakPay}
            target="_blank"
          >
            Заявление на поступление (Внебюджет)
          </Link>{" "}
          <br />
          <Link
            to={personalData}
            target="_blank"
          >
            Согласие на обработку персональных данных абитуриента
          </Link>
          <br />
          <Link
            to={agreedVo}
            target="_blank"
          >
            Согласие на зачисление
          </Link>
        </p>
        <p
          style={{
            padding: "10px",
            color: "white",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "#eb3434",
          }}
        >
          При поступлении в наш университет вы можете выбрать до 5
          специальностей или направлений подготовки.
        </p>
        <h6>
          Документы, необходимые для поступления в университет, можно подать
          одним из следующих способов:
        </h6>
        <ul>
          <li>
            Лично абитуриентом (
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleShowAddressModal();
              }}
            >
              адрес приемной комиссии
            </Link>
            )
          </li>
          <li>
            Через операторов почтовой связи общего пользования (
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                modalRef.current.openModal();
              }}
            >
              адрес для отправки документов
            </Link>
            )
          </li>
          <InfoModal
            ref={modalRef}
            title={addressForSendingDocumentsTitle}
            description={addressForSendingDocuments}
          />
          <li>
            На{" "}
            <Link to="https://asu.art-gzhel.ru/default.aspx?WCI=ORDERWIZARD&WCE=GOTO.STEP.0" target="_blank">
              сайте
            </Link>{" "}
            университета
          </li>
          <li>
            На едином портале государственных услуг (
            <Link
              to="https://www.gosuslugi.ru/vuzonline"
              target="_blank"
            >
              Госуслуги
            </Link>
            )
          </li>
          <li>
            Отправив комплект документов на почту:{" "}
            <a href="mailto:ggu-vo@yandex.ru">ggu-vo@yandex.ru</a>
          </li>
        </ul>
        {/* <h2>
          Информация о необходимости прохождения поступающими обязательного
          предварительного медицинского осмотра (обследования)
        </h2>
        <p>
          При поступлении на обучение по направлениям подготовки, входящим в
          Перечень направлений подготовки:{" "}
        </p>
        <ul>
          <li>44.03.01 – Педагогическое образование</li>
          <li>44.03.02 – Психолого-педагогическое образование</li>
        </ul>
        при приеме на обучение по которым поступающие проходят обязательные
        предварительные медицинские осмотры (обследования) в порядке,
        установленном при заключении трудового договора или служебного контракта
        по соответствующей должности или специальности, утвержденный
        постановлением{" "}
        <b>Правительства Российской Федерации от 14 августа 2013 г. № 69734</b>,
        поступающий представляет оригинал или копию медицинской справки
        (заключения). */}
        <AddressModal
          show={showAddressModal}
          onHide={handleCloseAddressModal}
        />
      </div>
    );
};

export default App2;